var exports = {
  "KO": "dialogHeader__9u7Zug",
  "az": "Box__ZViD4c",
  "lG": "Dialog__UT-4l9",
};

module.exports = exports;
